import { useState } from 'react';

export const useTooltip = () => {
    const [tooltip, setTooltip] = useState({
        visible: false,
        text: "",
        top: 0,
        left: 0
    });

    const showTooltip = (e, cinemaName, showtimes) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const showtimesText = showtimes.join("\n");
        const offset = 10;

        setTooltip({
            visible: true,
            text: `${cinemaName}:\n${showtimesText}`,
            top: rect.top - offset,
            left: rect.left + rect.width / 2,
        });
    };

    const hideTooltip = () => {
        setTooltip({ visible: false, text: "", top: 0, left: 0 });
    };

    return { tooltip, showTooltip, hideTooltip };
};